import styled from '@emotion/styled';

export const ColorButton = styled.button`
    width: 42px;
    height: 24px;
    border-radius: 2px;
    outline: none;
    border: solid 2px ${({ theme }) => theme.color.black200};
    cursor: pointer;
`;
